import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { notification, Button, Descriptions, Input, Radio, Select } from 'antd';
import CenterListModal from './CenterListModal';

@inject('userInfoStore')
@observer
class UserDetail extends Component {
  state = {
    saveData: {
      userId: '',
      userNm: '',
      userCeCd: '',
      userCeNm: '',
      userJobCd: '',
      userJobNm: '',
      userSex: 'M',
      userUseYn: 'Y',
    },

    modalOpen: false
  };

  onChangValue = (dataVal, dataNm) => {
    if (dataNm === 'userHp1' || dataNm === 'userHp2' || dataNm === 'userHp3') {
      dataVal = dataVal.replace(/[^0-9]/g, "");
      if(dataVal.length > 4) return;
    }

    if (dataNm === 'userId') {
      this.props.userInfoStore.onChangValue('checkUserId', false);
    }

    this.setState({
      saveData: {
        ...this.state.saveData,
        [dataNm]: dataVal
    }});
  };

  setData = (mode) => {
    this.props.userInfoStore.onViewMode(mode);
    if (mode === 'detail' || mode === 'add') {
      this.setState({
        saveData: {
          userId: '',
          userNm: '',
          userCeCd: '',
          userCeNm: '',
          userJobCd: '',
          userJobNm: '',
          userSex: 'M',
          userUseYn: 'Y',
      }});
    } else if (mode === 'mod') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.userInfoStore.detailData,
      }});
    }
  };

  onSave = () => {
    if (this.state.saveData.userId === '') {
      notification.warning({placement: 'bottomLeft', message: `사번을 입력하세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.userNm === '') {
      notification.warning({placement: 'bottomLeft', message: `사원명을 입력하세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.userCeCd === '') {
      notification.warning({placement: 'bottomLeft', message: `센터를 선택해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.userJobCd === '') {
      notification.warning({placement: 'bottomLeft', message: `직무를 선택해주세요.`, duration: 2});
      return false;
    }

    if (this.props.userInfoStore.viewMode === 'add') {
      if (this.props.userInfoStore.valCondition.checkUserId === false) {
        notification.warning({placement: 'bottomLeft', message: `사번 중복체크를 해주세요.`, duration: 2});
        return false;
      }
      this.props.userInfoStore.addUserInfo(this.state.saveData);
    } else if (this.props.userInfoStore.viewMode === 'mod') {
      this.props.userInfoStore.modUserInfo(this.state.saveData);
    }
  };

  render() {
    const { viewMode, valCondition, detailData, disUserCheck, jobList } = this.props.userInfoStore;
    const { saveData, modalOpen } = this.state;
    return (
      <Fragment>
        <div className="button-group">
          <h2>정보
            {viewMode === 'detail' && <Fragment> 상세보기</Fragment>}
            {viewMode === 'add' && <Fragment> 추가</Fragment>}
            {viewMode === 'mod' && <Fragment> 수정</Fragment>}
          </h2>
          <div className="button-right">
            {viewMode === 'detail'
            ? <ul>
                <li><Button type="primary" onClick={()=>this.setData('list')}>목록</Button></li>
                <li><Button type="primary" onClick={()=>this.setData('mod')}>수정</Button></li>
              </ul>
            : <ul>
                <li><Button type="primary" onClick={()=>this.onSave()}>저장</Button></li>
                <li><Button type="primary" onClick={()=>this.setData(viewMode === 'add' ? 'list' : 'detail')}>취소</Button></li>
              </ul>
            }
          </div>
        </div>
        <div className="table_th_W">
          <Descriptions bordered>
            <Descriptions.Item label="사번 *" span={2}>
              {(viewMode === 'detail' || viewMode === 'mod')
              ? (detailData !== null && detailData.userId !== undefined && detailData.userId !== null && detailData.userId)
              : <Fragment>
                  <Input
                    style={{ width: '40%' }}
                    value={saveData.userId}
                    onChange={(e)=>this.onChangValue(e.target.value, 'userId')}
                  />
                  {valCondition.checkUserId === false &&
                    <Button
                      type="primary"
                      onClick={()=>{
                        saveData.userId === '' 
                        ? notification.warning({placement: 'bottomLeft', message: `체크할 값을 입력하세요.`, duration: 2})
                        : disUserCheck(saveData.userId);
                      }}
                    >중복체크</Button>
                  }
                </Fragment>
              }
            </Descriptions.Item>
            <Descriptions.Item label="사용유무 *">
              {viewMode === 'detail'
              ? ((detailData !== null && detailData.userUseYn !== undefined && detailData.userUseYn !== null) && 
                detailData.userUseYn === 'Y' ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>)
              : <Radio.Group
                  onChange={(e)=>this.onChangValue(e.target.value, 'userUseYn')}
                  value={(saveData !== null && saveData.userUseYn !== undefined && saveData.userUseYn !== null) ? saveData.userUseYn : 'N'}
                >
                  <Radio value={"Y"}>사용</Radio>
                  <Radio value={"N"}>미사용</Radio>
                </Radio.Group>
              }
            </Descriptions.Item>
            <Descriptions.Item label="직원명 *" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.userNm !== undefined && detailData.userNm !== null && detailData.userNm)
              : <Input
                  value={saveData.userNm}
                  onChange={(e)=>this.onChangValue(e.target.value, 'userNm')}
                />
              }
            </Descriptions.Item>
            <Descriptions.Item label="센터 *" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.userCeNm !== undefined && detailData.userCeNm !== null && 
                <span style={{marginLeft: '10px'}}>{detailData.userCeNm}</span>)
              : <Fragment>
                  <Button 
                    type="primary"
                    onClick={()=>this.setState({modalOpen: true})}
                  >센터 검색</Button>
                  {saveData !== null && saveData.userCeNm !== undefined && saveData.userCeNm !== null && 
                    <span style={{marginLeft: '10px'}}>{saveData.userCeNm}</span>}
                </Fragment>
              }
            </Descriptions.Item>
            <Descriptions.Item label="직무 *" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.userJobNm !== undefined && detailData.userJobNm !== null && detailData.userJobNm)
              : <Select
                  style={{ width: '20%' }}
                  value={saveData.userJobCd}
                  onChange={(value)=>this.onChangValue(value, 'userJobCd')}
                >
                  {jobList.length > 0 && jobList.map(item=>{
                    return(
                      (item.jobCd !== '개별사업자') &&
                      <Select.Option key={item.jobCd}>{item.jobNm}</Select.Option>
                    )
                  })}
                </Select>
              }
            </Descriptions.Item>
            <Descriptions.Item label="성별 *" span={3}>
              {viewMode === 'detail'
              ? ((detailData !== null && detailData.userSex !== undefined && detailData.userSex !== null) && 
                detailData.userSex === 'M' ? <Fragment>남</Fragment> : <Fragment>여</Fragment>)
              : <Radio.Group
                  onChange={(e)=>this.onChangValue(e.target.value, 'userSex')}
                  value={(saveData !== null && saveData.userSex !== undefined && saveData.userSex !== null) ? saveData.userSex : 'M'}
                >
                  <Radio value={"M"}>남</Radio>
                  <Radio value={"F"}>여</Radio>
                </Radio.Group>
              }
            </Descriptions.Item>
          </Descriptions>
        </div>
        <CenterListModal
          modalOpen={modalOpen}
          modalClose={()=>this.setState({modalOpen: false})}
          setCenterInfo={(data)=>{
            this.setState({
              saveData: {
                ...saveData,
                userCeCd: data.ceCd,
                userCeNm: data.ceNm,
              }
            });
          }}
        />
        
      </Fragment>
    );
    
  }
}

export default withRouter(UserDetail);
